/** Etiqueta unificada Check ID en Laboral y Trámites (solo UI). */
export const VALIDADOR_DATOS_CHECK_ID_LABEL = "Validador de datos (Check ID)";

/** Ruta propia NSS dentro del módulo Trámites (sin embebido laboral). */
export const TRAMITES_VALIDADOR_NSS_PATH = "/tramites/validador-nss";
